export default "__VITE_ASSET__B9Jmom5B__"